import { AriaHidden } from "@swiggy-private/core-ui";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const SelectedLabel = styled(Text)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    background: theme.colors[theme.colorMode].positive_Sub,
    padding: `${theme.spacing.xxxSmall} ${theme.spacing.xSmall}`,
    borderRadius: theme.spacing.large,
}));

export const AddressListHeader = styled(Text)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: `${theme.spacing.large} ${theme.spacing.medium}`,
    outline: 0,
}));

export const AddressListContentContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing.medium,
    paddingTop: theme.spacing.empty,
}));

export const AddNewAddressButton = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing.xxxSmall,
    paddingBottom: theme.spacing.large,
}));

export const AddNewAddressButtonIcon = styled(AriaHidden)(({ theme }) => ({
    padding: `${theme.spacing.xSmall} ${theme.spacing.medium}`,
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    borderRadius: theme.cornerRadius.xSmall,
    marginRight: theme.spacing.small,
}));

export const AddressLocationDescription = styled(Text)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
});

export const AddressAnnotation = styled(Text)(({ theme }) => ({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    marginBottom: theme.spacing.xxSmall,
}));

export const AddressTitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.xxSmall,
    width: "80%",
}));
export const AddressDescription = styled(AriaHidden)(({ theme }) => ({
    paddingLeft: theme.spacing.medium,
    width: `calc(100% - ${theme.spacing.xLarge})`,
}));

export const IconWrapper = styled.div(({ theme }) => ({
    borderRadius: theme.spacing.xSmall,
    minWidth: "48px",
    width: "48px",
    height: "42px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: theme.colors[theme.colorMode].border_Tertiary,
    gap: theme.spacing.xxxSmall,
}));

export const AddressContentContainer = styled.div({
    display: "flex",
    width: "100%",
    alignItems: "flex-start",
});

export const AddressContentWrapper = styled.div(({ theme }) => ({
    borderTop: ` 1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    padding: `${theme.spacing.medium} ${theme.spacing.empty}`,
}));

export const AwayAddressWarning = styled(Text)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xSmall,
    background: `linear-gradient(90deg, ${theme.colors[theme.colorMode].warning_Sub} 0%, ${
        theme.colors[theme.colorMode].background_Primary
    } 95%)`,
    padding: theme.spacing.xSmall,
    marginTop: theme.spacing.xSmall,
    marginLeft: "61px",
    borderRadius: theme.cornerRadius.halfRounded,
}));
